
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software-solutions-sitemap.xml",
      function () {
        return require("private-next-pages/software-solutions-sitemap.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software-solutions-sitemap.xml"])
      });
    }
  